import Mango from "./mango/index.js";
import PetrolCard from "./petrolcard/index.js";

export default {
  Mango,
  PetrolCard,
};
